import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { CustomInput, FormGroup } from 'reactstrap';
import Datagrid from '../../../../UI/Datagrid';
import {
  dashboardCustomizeAlarmListData,
  dashboardCustomizeCMVData,
} from '../constants';
import ActionsDropdown from '../../../Dashboard/helpers/ActionsDropdown';
import helper from '../../../../../utils/helper';

const dummyFunc = () => {};
const CMVSection = ({ values, ...props }) => {
  const { t } = useTranslation('app');
  const columns = [
    {
      dataField: 'location',
      text: 'Location',
      sort: true,
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
    },
    {
      dataField: 'parameter',
      text: 'Parameter',
      sort: true,
    },
    {
      dataField: 'textValue',
      text: 'Value',
      sort: true,
    },
    {
      dataField: 'units',
      text: 'Units',
      sort: true,
    },
    {
      dataField: 'alarmImage',
      text: 'Status',
      sort: true,
      formatter: formatterStatus,
    },
    {
      dataField: 'timeStamp',
      text: 'Time Last Updated',
      sort: true,
      isDateTime: true,
      headerStyle: { width: 150 },
    },
  ];
  const defaultSorted = [
    {
      dataField: 'name',
      order: 'asc',
    },
  ];
  function formatterStatus(cell) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <img
          src={process.env.PUBLIC_URL + `/img/statusIcon/${cell}`}
          width={24}
          height={24}
          alt="status-icon"
          title={t(helper.getStatusIconName(cell))}
        />
      </div>
    );
  }
  const cmvActions = [
    { label: 'Show map', action: dummyFunc },
    { label: 'Add note', action: dummyFunc },
    { label: 'Show trend chart', action: dummyFunc },
    { label: 'Sensor disable', action: dummyFunc },
    { label: 'Sensor enable', action: dummyFunc },
    { label: 'Sensor info', action: dummyFunc },
    { label: 'Edit group', action: dummyFunc },
    { label: 'Maintain database', action: dummyFunc },
  ];
  const ctxMenuOptions = [
    [
      { name: 'Show map', action: dummyFunc },
      { name: 'Add note', action: dummyFunc },
      { name: 'Show trend chart', action: dummyFunc },
      { name: 'Sensor disable', action: dummyFunc },
      { name: 'Sensor enable', action: dummyFunc },
      { name: 'Sensor info', action: dummyFunc },
      { name: 'Edit monitoring point', action: dummyFunc },
      { name: 'Edit sensor type settings', action: dummyFunc },
      { name: 'Edit group', action: dummyFunc },
      { name: 'Maintain database', action: dummyFunc },
    ],
  ];
  return (
    <>
      <div className="d-flex justify-content-between align-items-end mb-10">
        <div>
          <h1>
            {props.groupName} ({props.groupState ? 'At Rest' : 'In Operation'})
          </h1>
          {/* <h1>{values.title}</h1>
          <span style={{ fontStyle: 'italic' }}>{values.description}</span> */}
        </div>
        <div className="d-flex justify-content-end align-items-end">
          <div
            className="d-flex"
            style={{
              marginRight: 10,
              padding: 5,
            }}
          >
            <div>
              <span style={{ fontWeight: 600 }}>{t('Sensors')}: 1,</span>
              <span style={{ fontWeight: 600 }}>{t('Errors')}: 2,</span>
              <span style={{ fontWeight: 600 }}>{t('Alarms')}: 3,</span>
              <span style={{ fontWeight: 600 }}>{t('Warnings')}: 4,</span>
              <span style={{ fontWeight: 600 }}>{t('Overriden')}: 0</span>
            </div>
          </div>
          <ActionsDropdown options={cmvActions} />
        </div>
      </div>
      <Datagrid
        datagridProps={{
          keyField: 'sensorId',
          data: dashboardCustomizeCMVData,
          columns,
          defaultSorted,
          //   selectRow,
        }}
        classes="mobile-datagrid-responsive"
        ctxMenuId="CMV-context"
        ctxMenuOptions={ctxMenuOptions}
        exportProps={{
          fileName: `AlarmList-${moment().format('MM-DD-YYYY')}.csv`,
        }}
      />
    </>
  );
};

export default CMVSection;
